module.exports = __webpack_public_path__ + "static/plane-horizontal-d01f50879429c1a1fb4ae2f1d2edd361.png";